'use strict';

module.exports = require('common/utils/hf-react-helper');


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/hf-react-helper.js
 ** module id = 772
 ** module chunks = 0 1
 **/